const header_btn = document.querySelector(".header-btn .button");

if(header_btn){

header_btn.addEventListener("mouseenter", () => {
  const header_form = document.querySelector(".mega-menu-form");
  const main = document.querySelector("#main");
  const header_title = document.querySelectorAll(".header__primary-nav .link-reversed");

   header_form.classList.add("show");

  main.addEventListener("mouseover", () => {
    header_form.classList.remove("show");
  });

  header_title.forEach((title) => {
    title.addEventListener("mouseover", () => {
      header_form.classList.remove("show");
    });
  });
});
}
